/* eslint-disable react/prop-types */
import isEmpty from 'lodash/isEmpty';
import React from 'react';
import {loadable, isSearchPage} from 'router/routes';
import {fetchCleanedData} from 'router/router-utils';
import EventsAPI from 'api/events';
import merge from 'lodash/merge';
import includes from 'lodash/includes';
import Config from 'config';
import {Page} from './utils';

const SearchMobileTransient = loadable(() =>
    import('search/SearchMobileTransient')
);
const SearchMobileMonthly = loadable(() =>
    import('search/SearchMobileMonthly')
);
const SearchMobileEvent = loadable(() => import('search/SearchMobileEvent'));
const SearchMobileDestination = loadable(() =>
    import('search/SearchMobileDestination')
);
const SearchDesktopTransient = loadable(() =>
    import('search/SearchDesktopTransient')
);
const SearchDesktopMonthly = loadable(() =>
    import('search/SearchDesktopMonthly')
);
const SearchDesktopEvent = loadable(() => import('search/SearchDesktopEvent'));
const SearchDesktopDestination = loadable(() =>
    import('search/SearchDesktopDestination')
);
const MidFunnelAirport = loadable(() =>
    import('mid-funnel/airport/MidFunnelAirport')
);
const NotFound = loadable(() => import('router/NotFound'));

const SearchPage = ({
    configData: {isMobile},
    isMonthly,
    destination,
    pageType,
}) => {
    if (isMonthly) {
        return isMobile ? <SearchMobileMonthly /> : <SearchDesktopMonthly />;
    }

    if (isMobile) {
        return pageType === 'event' ? (
            <SearchMobileEvent />
        ) : !isEmpty(destination) ? (
            <SearchMobileDestination />
        ) : (
            <SearchMobileTransient />
        );
    }

    return pageType === 'event' ? (
        <SearchDesktopEvent />
    ) : !isEmpty(destination) ? (
        <SearchDesktopDestination />
    ) : (
        <SearchDesktopTransient />
    );
};

function CatchAll({configData, isMonthly, destination, match, pageType}) {
    const {
        params: {page, section},
    } = match;

    if (
        (!section && includes(configData.citySlugs, page)) ||
        isSearchPage(page, section)
    ) {
        if (destination && destination.airport && !isMonthly) {
            return <MidFunnelAirport />;
        }

        return (
            <SearchPage
                configData={configData}
                isMonthly={isMonthly}
                destination={destination}
                pageType={pageType}
            />
        );
    }

    return <NotFound />;
}

CatchAll.getInitialState = async ({state: initialState, route}) => {
    const state = await fetchCleanedData({
        state: initialState,
        route,
    });
    const {
        destination: {
            data: {id: destinationId, has_upcoming_events: hasEvents},
        },
        searchRequest: {pageType},
    } = state;

    if (pageType !== Page.EVENT && hasEvents && !Config.isMobile) {
        const events = await EventsAPI.get({destinationId}).then(
            res => res.data.data.results
        );

        return merge({}, state, {
            destination: {
                data: {
                    events,
                },
            },
        });
    }

    return state;
};

export default CatchAll;
